import { TUserGroupsState } from './types';

export function getAreas(state: TUserGroupsState) {
  return state.areas;
}

export function getCountries(state: TUserGroupsState) {
  return state.countries;
}

export function getAreaCountryLinks(state: TUserGroupsState) {
  return state.areaCountryLinks;
}

export function getCustomsItems(state: TUserGroupsState) {
  return state.customsItems;
}

export function getTransportGroups(state: TUserGroupsState) {
  return state.transportGroups;
}

export function getTransportItems(state: TUserGroupsState) {
  return state.transportItems;
}

export function getGoodsGroups(state: TUserGroupsState) {
  return state.goodsGroups;
}

export function getGoodsItems(state: TUserGroupsState) {
  return state.goodsItems;
}

export function getGoodsUnits(state: TUserGroupsState) {
  return state.goodsUnits;
}
